 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import Mention from '@tiptap/extension-mention'






export const PageUserMention = Mention.extend({
  name: 'pageUserMention',
  addOptions() {
    return {
      ..._optionalChain([this, 'access', _ => _.parent, 'optionalCall', _2 => _2()]),
      atmosphere: undefined
    } 
  },
  renderText({node}) {
    return node.attrs.label
  },
  renderHTML({HTMLAttributes, node}) {
    return ['span', {...HTMLAttributes, class: 'page-user-mention'}, `@${node.attrs.label}`]
  }
})
